import React from 'react'

const description = (
    <div>
        There are two types of transaction checks:
        <ul>
            <li><b>script</b>: the legacy TMS check created with predefined commands in the Pingdom UI or via the public API</li>
            <li><b>recording</b>: the TMS check created by recording performed actions in WPM recorder.
                More information about how to use it can be found in the&nbsp;
                <a href="https://documentation.solarwinds.com/en/success_center/wpm/Content/WPM-Use-the-WPM3-Recorder.htm">
                    WPM recorder documentation</a>
            </li>
        </ul>

        For more information about possible commands, please check our&nbsp;
        <a href="#section/TMS-Steps-Vocabulary">vocabulary</a> in the description.
    </div>
);

export { description };
